import { render, staticRenderFns } from "./radiogroupitem.vue?vue&type=template&id=5bbe97b9&"
import script from "./radiogroupitem.vue?vue&type=script&lang=ts&"
export * from "./radiogroupitem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbe97b9')) {
      api.createRecord('5bbe97b9', component.options)
    } else {
      api.reload('5bbe97b9', component.options)
    }
    module.hot.accept("./radiogroupitem.vue?vue&type=template&id=5bbe97b9&", function () {
      api.rerender('5bbe97b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/radiogroupitem.vue"
export default component.exports